export function buildPermissionRows(catalog = [], activeCodes = [], inheritedCodes = []) {
  const active = new Set(activeCodes.map(String));
  const inherited = new Set(inheritedCodes.map(String));
  const rows = [];
  let sectionKey = null;

  catalog.forEach(item => {
    if (item.section_key !== sectionKey) {
      sectionKey = item.section_key;
      rows.push({
        id: `section-${sectionKey}`,
        code: "",
        name: item.section_name,
        row_type: "section",
        section_name: item.section_name,
        parent_id: 0,
        assignable: false,
      });
    }

    const code = String(item.code);
    rows.push({
      ...item,
      code,
      row_type: item.is_group ? "module" : "permission",
      access_status_position: !item.is_group && inherited.has(code),
      access_status: !item.is_group && (active.has(code) || inherited.has(code)),
    });
  });

  return rows;
}

export function permissionSummary(rows = []) {
  return {
    modules: rows.filter(row => row.row_type === "module").length,
    permissions: rows.filter(row => row.row_type === "permission").length,
    active: rows.filter(row => row.row_type === "permission" && row.access_status).length,
  };
}
